import { createFileRoute } from "@tanstack/react-router";
import { useContext } from "react";
import { Badge } from "@bfc-software/pallet";
import { AuthContext, AuthUtils } from "@bfc-software/app-toolbox";
import {
  useTranslation,
  TRANSLATION_NAMESPACE,
} from "@bfc-software/bfc-web-ui/i18n";

import { SystemSettingsCard } from "./-components/system-settings-card";
import { ShiftsCard } from "./-components/shifts-card";
import { UserProfileCard } from "./-components/user-profile-card";
import styles from "./index.module.css";

export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/system-controls/",
)({
  component: RouteComponent,
});

export function RouteComponent() {
  const params = Route.useParams();
  const { lang } = params;
  const { state: authState } = useContext(AuthContext);
  const { t } = useTranslation({
    lang,
    namespace: TRANSLATION_NAMESPACE.outbound,
  });

  // eslint-disable-next-line no-restricted-properties -- TODO: migrate to useAssertedTenancyContext()
  const orgId = AuthUtils.getOrgIdByStub(authState, params.org) ?? params.org;
  // eslint-disable-next-line no-restricted-properties -- TODO: migrate to useAssertedTenancyContext()
  const warehouseId = AuthUtils.getWarehouseId(
    authState,
    orgId,
    params.location,
  );

  return (
    <div className="bg-surface h-full w-full">
      <div className="page-shell">
        <header className="page-header">
          <div className="page-header-left">
            <div className={styles.headingRow}>
              <h1 className="page-title">{t("systemControls.heading")}</h1>
              <Badge
                label={t("systemControls.badge")}
                color={{ mode: "static", tone: "purple" }}
              />
            </div>
            <p className="page-subtitle">{t("systemControls.subheading")}</p>
          </div>
        </header>

        <div className={styles.grid}>
          <div className={styles.mainColumn}>
            <SystemSettingsCard orgId={orgId} warehouseId={warehouseId} t={t} />
            <ShiftsCard orgId={orgId} warehouseId={warehouseId} t={t} />
          </div>
          <div className={styles.sideColumn}>
            <UserProfileCard orgId={orgId} warehouseId={warehouseId} t={t} />
          </div>
        </div>
      </div>
    </div>
  );
}
